var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar hide-for-large",attrs:{"data-responsive-toggle":"top-menu","data-hide-for":"large"}},[_c('button',{staticClass:"menu-icon",attrs:{"type":"button","id":"mobile-menu-icon","data-toggle":"top-menu"},on:{"click":_vm.toggleMobileMenu}})])
}
var staticRenderFns = []

export { render, staticRenderFns }